import axios from "axios";
import { parseISO } from "date-fns";
import Decimal from "decimal.js";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { PaginationMetadata, PortfolioPlanAssignmentId, PrePortfolioPackId, TaxBudgetId, } from "../../Types";
import ValidationError from "../../ZodError";
const Response = z.object({
    data: z
        .object({
        batchId: PrePortfolioPackId,
        expireTime: z
            .string()
            .transform((x) => parseISO(x))
            .nullable(),
        minimumAccountFreshness: z.string().transform((x) => parseISO(x)),
        assignments: z
            .object({
            portfolioPlanAssignmentId: PortfolioPlanAssignmentId,
            PortfolioPlanAssignmentVersion: z.number(),
            taxBudget: z
                .object({
                taxBudgetId: TaxBudgetId,
                taxBudgetUpdatedAt: z.string().transform((x) => parseISO(x)),
            })
                .nullable(),
            taxBracket: z.object({
                incomeTaxRate: z.string().transform((x) => new Decimal(x)),
                capitalGainsTaxRate: z.string().transform((x) => new Decimal(x)),
            }),
        })
            .array(),
    })
        .array(),
    pagination: PaginationMetadata,
});
export const url = (pagination) => {
    const qs = new URLSearchParams();
    qs.append("page", pagination.page.toString());
    qs.append("pageSize", pagination.pageSize.toString());
    qs.append("orderBy", pagination.orderBy);
    return environment() === "PROD"
        ? `https://middleware.prod.farther.com/investment/rebalancer/staged-trading-pack?${qs.toString()}`
        : `https://middleware.uat.farther.com/investment/rebalancer/staged-trading-pack?${qs.toString()}`;
};
export const getStagedTradingPacks = async (pagination, config) => {
    const { data } = await axios.get(url(pagination), {
        headers: {
            version: "20241028",
            Authorization: `Bearer ${config.jwt}`,
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
    });
    const decoded = Response.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[getItbs.ts] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getStagedTradingPacks.js.map